export default __webpack_public_path__ + "static/media/conventus-3.6fa652cb.png";